import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import SpinnerIcon from "./Spinner.svg";

export const SPINNER_SIZES = {
  SMALL: 20,
  MEDIUM: 32,
  LARGE: 64
};

export function Spinner(props) {
  const { className, size, spinnerDelay } = props;
  const [showSpinner, setShowSpin] = useState(false);

  useEffect(
    function delaySpinnerRendering() {
      const spinTimeOut = setTimeout(() => {
        setShowSpin(true);
        clearTimeout(spinTimeOut);
      }, spinnerDelay);

      return () => clearTimeout(spinTimeOut);
    },
    [spinnerDelay]
  );

  if (!showSpinner) return null;

  return (
    <SpinnerIcon
      className={className}
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  );
}

Spinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  spinnerDelay: PropTypes.number
};

Spinner.defaultProps = {
  size: 20,
  spinnerDelay: 1000
};
